module.exports = "<p>\n  ajoutanticoagulant works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/ajoutanticoagulant/ajoutanticoagulant.component.html
// module id = ../../../../../src/app/ajoutanticoagulant/ajoutanticoagulant.component.html
// module chunks = main